import AppSerializer from 'serializers/app';

class IntervalSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}


	get relationships() {
		return {
			schedule: { serialize: 'id' },
		}
	}

}

export default IntervalSerializer;